import { useState, useEffect } from "react";
import {
  Document, Page, Text, View, StyleSheet, PDFViewer, Svg, Line, Rect, Path,
} from "@react-pdf/renderer";

// ─── DEMO DATA ────────────────────────────────────────────────────────────────
const deliveryData = {
  type: "DELIVERY",
  serialNo: "2026-27/0042",
  date: "07/06/2026",
  placeOfSupply: "Sector 62, Noida, UP - 201301",
  vehicleNo: "DL 1C 2345",
  grNo: "GR-20260607-88",
  consignee: {
    name: "M/s. Rajesh Constructions Pvt. Ltd.",
    address: "Plot No. 14, Sector 62, Noida, Uttar Pradesh - 201301",
    gstin: "09AABCR1234F1ZX",
  },
  items: [
    { srNo: 1,  description: "H-Frame (1.9m x 1.2m)",      hsnCode: "73084000", qty: 120, amount: 18000 },
    { srNo: 2,  description: "Cross Brace (1.8m)",           hsnCode: "73084000", qty: 240, amount: 14400 },
    { srNo: 3,  description: "Screw Jack (0.6m)",            hsnCode: "73084000", qty: 80,  amount: 6400  },
    { srNo: 4,  description: "Base Plate (200x200mm)",       hsnCode: "73084000", qty: 80,  amount: 3200  },
    { srNo: 5,  description: "Swivel Coupler",               hsnCode: "73084000", qty: 160, amount: 4800  },
    { srNo: 6,  description: "Right Angle Coupler",          hsnCode: "73084000", qty: 160, amount: 4800  },
    { srNo: 7,  description: "Toe Board Clip",               hsnCode: "73084000", qty: 60,  amount: 1200  },
    { srNo: 8,  description: "Ledger Tube (2.5m)",           hsnCode: "73084000", qty: 100, amount: 7500  },
    { srNo: 9,  description: "Transom Tube (1.2m)",          hsnCode: "73084000", qty: 80,  amount: 4800  },
    { srNo: 10, description: "Standard Tube (3.0m)",         hsnCode: "73084000", qty: 60,  amount: 5400  },
    { srNo: 11, description: "Plank (2.5m x 0.225m)",       hsnCode: "73084000", qty: 50,  amount: 6250  },
    { srNo: 12, description: "Stairway Unit",                hsnCode: "73084000", qty: 4,   amount: 2000  },
    { srNo: 13, description: "Diagonal Brace (2.0m)",        hsnCode: "73084000", qty: 40,  amount: 2400  },
    { srNo: 14, description: "Slab Prop (3.0-4.5m)",        hsnCode: "73084000", qty: 30,  amount: 4500  },
    { srNo: 15, description: "Prop Nut",                     hsnCode: "73084000", qty: 30,  amount: 900   },
    { srNo: 16, description: "U-Head Jack (0.6m)",           hsnCode: "73084000", qty: 30,  amount: 1500  },
    { srNo: 17, description: "Cup Lock Standard (3.0m)",     hsnCode: "73084000", qty: 20,  amount: 2200  },
    { srNo: 18, description: "Cup Lock Ledger (1.5m)",       hsnCode: "73084000", qty: 40,  amount: 2800  },
  ],
  totalAmountFigures: "93050.00",
  totalAmountWords: "Ninety Three Thousand and Fifty Rupees Only",
};

const receiptData = {
  type: "RECEIPT",
  serialNo: "2026-27/0031",
  date: "07/06/2026",
  placeOfReceiving: "Khasra No. 99/1, Village Budhpur, Delhi-110036",
  vehicleNo: "DL 1C 2345",
  grNo: "GR-20260607-88",
  hirer: {
    name: "M/s. Rajesh Constructions Pvt. Ltd.",
    address: "Plot No. 14, Sector 62, Noida, Uttar Pradesh - 201301",
    gstin: "09AABCR1234F1ZX",
  },
  items: [
    { srNo: 1,  description: "H-Frame (1.9m x 1.2m)",      hsnCode: "73084000", qty: 120, amount: 18000 },
    { srNo: 2,  description: "Cross Brace (1.8m)",           hsnCode: "73084000", qty: 240, amount: 14400 },
    { srNo: 3,  description: "Screw Jack (0.6m)",            hsnCode: "73084000", qty: 80,  amount: 6400  },
    { srNo: 4,  description: "Base Plate (200x200mm)",       hsnCode: "73084000", qty: 80,  amount: 3200  },
    { srNo: 5,  description: "Swivel Coupler",               hsnCode: "73084000", qty: 160, amount: 4800  },
    { srNo: 6,  description: "Right Angle Coupler",          hsnCode: "73084000", qty: 160, amount: 4800  },
    { srNo: 7,  description: "Toe Board Clip",               hsnCode: "73084000", qty: 60,  amount: 1200  },
    { srNo: 8,  description: "Ledger Tube (2.5m)",           hsnCode: "73084000", qty: 100, amount: 7500  },
    { srNo: 9,  description: "Transom Tube (1.2m)",          hsnCode: "73084000", qty: 80,  amount: 4800  },
    { srNo: 10, description: "Standard Tube (3.0m)",         hsnCode: "73084000", qty: 60,  amount: 5400  },
    { srNo: 11, description: "Plank (2.5m x 0.225m)",       hsnCode: "73084000", qty: 50,  amount: 6250  },
    { srNo: 12, description: "Stairway Unit",                hsnCode: "73084000", qty: 4,   amount: 2000  },
    { srNo: 13, description: "Diagonal Brace (2.0m)",        hsnCode: "73084000", qty: 40,  amount: 2400  },
    { srNo: 14, description: "Slab Prop (3.0-4.5m)",        hsnCode: "73084000", qty: 30,  amount: 4500  },
    { srNo: 15, description: "Prop Nut",                     hsnCode: "73084000", qty: 30,  amount: 900   },
    { srNo: 16, description: "U-Head Jack (0.6m)",           hsnCode: "73084000", qty: 30,  amount: 1500  },
    { srNo: 17, description: "Cup Lock Standard (3.0m)",     hsnCode: "73084000", qty: 20,  amount: 2200  },
    { srNo: 18, description: "Cup Lock Ledger (1.5m)",       hsnCode: "73084000", qty: 40,  amount: 2800  },
  ],
  totalAmountFigures: "93050.00",
  totalAmountWords: "Ninety Three Thousand and Fifty Rupees Only",
};

// ─── PAGE CHUNKING ────────────────────────────────────────────────────────────
const ROWS_FIRST = 12;
const ROWS_MORE  = 18;

function buildPages(items) {
  const pages = [];
  let rem = [...items];
  let i = 0;
  while (rem.length > 0) {
    const lim = i === 0 ? ROWS_FIRST : ROWS_MORE;
    pages.push(rem.slice(0, lim));
    rem = rem.slice(lim);
    i++;
  }
  return pages;
}

// ─── STYLES ───────────────────────────────────────────────────────────────────
const S = StyleSheet.create({
  page: {
    fontFamily: "Helvetica",
    fontSize: 7.5,
    color: "#000",
    paddingTop: 8,
    paddingBottom: 8,
    paddingHorizontal: 20,
    backgroundColor: "#fff",
  },

  // outer border of whole challan
  outerBorder: {
    borderWidth: 1,
    borderColor: "#000",
    flex: 1,
  },

  // ── TOP HEADER ──
  topRow: {
    flexDirection: "row",
    borderBottomWidth: 1,
    borderBottomColor: "#000",
  },
  topLeft: {
    flex: 1,
    paddingHorizontal: 5,
    paddingVertical: 3,
    borderRightWidth: 1,
    borderRightColor: "#000",
  },
  topRight: {
    width: 175,
    paddingHorizontal: 4,
    paddingVertical: 3,
  },
  gstinLine: { fontSize: 7, flexDirection: "row", justifyContent: "space-between" },
  gstinText: { fontSize: 7 },
  challanTitle: { fontSize: 9, fontFamily: "Helvetica-Bold", textAlign: "center", marginTop: 1 },
  cinText: { fontSize: 7, textAlign: "right" },
  // inward only
  receivedAtLine: { fontSize: 7.5, marginTop: 2 },
  // right panel rows
  sacRow: {
    backgroundColor: "#000",
    paddingHorizontal: 4,
    paddingVertical: 2,
    marginBottom: 2,
  },
  sacText: { color: "#fff", fontSize: 7.5, fontFamily: "Helvetica-Bold" },
  metaLineRow: { flexDirection: "row", paddingHorizontal: 4, paddingVertical: 2, borderTopWidth: 0.5, borderTopColor: "#000" },
  metaLineLabel: { fontSize: 7.5, fontFamily: "Helvetica-Bold", marginRight: 3 },
  metaLineVal: { fontSize: 7.5, flex: 1 },

  // ── COMPANY NAME ROW ──
  companyRow: {
    borderBottomWidth: 1,
    borderBottomColor: "#000",
    flexDirection: "row",
  },
  companyLeft: {
    flex: 1,
    paddingHorizontal: 5,
    paddingVertical: 3,
    borderRightWidth: 1,
    borderRightColor: "#000",
  },
  companyName: {
    fontSize: 20,
    fontFamily: "Helvetica-Bold",
    letterSpacing: 0.5,
  },
  companyAddr: { fontSize: 7, marginTop: 2, lineHeight: 1.4 },
  companyRight: {
    width: 175,
    paddingHorizontal: 4,
  },

  // ── VEHICLE ROW ──
  vehicleRow: {
    flexDirection: "row",
    borderBottomWidth: 1,
    borderBottomColor: "#000",
    paddingHorizontal: 5,
    paddingVertical: 4,
  },
  vehicleText: { flex: 1 },
  dotLine: { borderBottomWidth: 0.5, borderBottomColor: "#000", flex: 1, marginTop: 7, marginHorizontal: 3 },

  // ── DECLARATION (inward) ──
  declarationBox: {
    borderBottomWidth: 1,
    borderBottomColor: "#000",
    paddingHorizontal: 5,
    paddingVertical: 4,
  },
  declarationTitle: { fontFamily: "Helvetica-Bold", textAlign: "center", fontSize: 8, marginBottom: 2 },
  declarationLine: { fontSize: 7.5, lineHeight: 1.5 },
  dotLineInline: {
    borderBottomWidth: 0.5,
    borderBottomColor: "#000",
    marginTop: 6,
    marginBottom: 2,
  },

  // ── CONSIGNEE (delivery) ──
  consigneeBox: {
    borderBottomWidth: 1,
    borderBottomColor: "#000",
    paddingHorizontal: 5,
    paddingVertical: 4,
  },
  consigneeMsLine: { flexDirection: "row" },
  consigneeMsLabel: { fontSize: 7.5, fontFamily: "Helvetica-Bold", marginRight: 4 },
  consigneeDotLine: { flex: 1, borderBottomWidth: 0.5, borderBottomColor: "#000", marginTop: 7 },
  consigneeBlankLine: { borderBottomWidth: 0.5, borderBottomColor: "#000", marginTop: 5, marginBottom: 2 },
  consigneeGstinRow: { flexDirection: "row", marginTop: 3 },
  consigneeGstinLabel: { fontSize: 7.5, fontFamily: "Helvetica-Bold", marginRight: 4 },
  receiveNotice: { fontSize: 7.5, fontFamily: "Helvetica-Bold", marginTop: 4 },

  // ── TABLE ──
  tableHeaderRow: {
    flexDirection: "row",
    borderBottomWidth: 1,
    borderBottomColor: "#000",
    borderTopWidth: 1,
    borderTopColor: "#000",
    backgroundColor: "#fff",
  },
  thSr:   { width: 30, borderRightWidth: 1, borderRightColor: "#000", paddingVertical: 4, paddingHorizontal: 3, textAlign: "center" },
  thDesc: { flex: 1,   borderRightWidth: 1, borderRightColor: "#000", paddingVertical: 4, paddingHorizontal: 3, textAlign: "center" },
  thHsn:  { width: 55, borderRightWidth: 1, borderRightColor: "#000", paddingVertical: 4, paddingHorizontal: 3, textAlign: "center" },
  thQty:  { width: 55, borderRightWidth: 1, borderRightColor: "#000", paddingVertical: 4, paddingHorizontal: 3, textAlign: "center" },
  thAmt:  { width: 65, paddingVertical: 4, paddingHorizontal: 3, textAlign: "center" },
  thText: { fontFamily: "Helvetica-Bold", fontSize: 7.5, textAlign: "center" },

  dataRow: {
    flexDirection: "row",
    borderBottomWidth: 0.5,
    borderBottomColor: "#ccc",
    minHeight: 14,
  },
  tdSr:   { width: 30, borderRightWidth: 1, borderRightColor: "#000", paddingVertical: 2, paddingHorizontal: 3, textAlign: "center" },
  tdDesc: { flex: 1,   borderRightWidth: 1, borderRightColor: "#000", paddingVertical: 2, paddingHorizontal: 3 },
  tdHsn:  { width: 55, borderRightWidth: 1, borderRightColor: "#000", paddingVertical: 2, paddingHorizontal: 3, textAlign: "center" },
  tdQty:  { width: 55, borderRightWidth: 1, borderRightColor: "#000", paddingVertical: 2, paddingHorizontal: 3, textAlign: "center" },
  tdAmt:  { width: 65, paddingVertical: 2, paddingHorizontal: 3, textAlign: "right" },
  tdText: { fontSize: 7.5 },

  // HSN vertical text stamp
  hsnStamp: {
    position: "absolute",
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    justifyContent: "center",
    alignItems: "center",
  },

  totalRow: {
    flexDirection: "row",
    borderTopWidth: 1,
    borderTopColor: "#000",
    borderBottomWidth: 0,
  },
  totalSr:   { width: 30, borderRightWidth: 1, borderRightColor: "#000", paddingVertical: 3, paddingHorizontal: 3 },
  totalDesc: { flex: 1,   borderRightWidth: 1, borderRightColor: "#000", paddingVertical: 3, paddingHorizontal: 3 },
  totalHsn:  { width: 55, borderRightWidth: 1, borderRightColor: "#000", paddingVertical: 3, paddingHorizontal: 3, textAlign: "right" },
  totalQty:  { width: 55, borderRightWidth: 1, borderRightColor: "#000", paddingVertical: 3, paddingHorizontal: 3 },
  totalAmt:  { width: 65, paddingVertical: 3, paddingHorizontal: 3, textAlign: "right" },
  totalText: { fontFamily: "Helvetica-Bold", fontSize: 7.5 },

  // ── HATCHED BANNER ──
  hatchBanner: {
    height: 14,
    overflow: "hidden",
    borderTopWidth: 1,
    borderTopColor: "#000",
    borderBottomWidth: 1,
    borderBottomColor: "#000",
    justifyContent: "center",
    alignItems: "center",
    position: "relative",
  },
  hatchBannerText: {
    fontFamily: "Helvetica-Bold",
    fontSize: 8,
    letterSpacing: 1,
    color: "#000",
    textAlign: "center",
    zIndex: 1,
    backgroundColor: "#fff",
    paddingHorizontal: 8,
  },

  // ── VALUE LINE ──
  valueLine: {
    flexDirection: "row",
    borderBottomWidth: 1,
    borderBottomColor: "#000",
    paddingHorizontal: 5,
    paddingVertical: 3,
  },
  valueLabel: { fontFamily: "Helvetica-Bold", fontSize: 7.5, marginRight: 4 },
  valueDotLine: { flex: 1, borderBottomWidth: 0.5, borderBottomColor: "#000", marginTop: 7, marginRight: 10 },

  // ── TERMS (delivery) ──
  termsBox: {
    borderTopWidth: 0,
    paddingHorizontal: 5,
    paddingVertical: 3,
    borderBottomWidth: 1,
    borderBottomColor: "#000",
  },
  termsIntro: { fontSize: 7.5, marginBottom: 2 },
  termLine: { fontSize: 7, lineHeight: 1.5 },

  // ── SIGNATURE ──
  sigRow: {
    flexDirection: "row",
    paddingHorizontal: 5,
    paddingVertical: 3,
    borderBottomWidth: 1,
    borderBottomColor: "#000",
  },
  sigLeft: { flex: 1 },
  sigRight: { flex: 1, alignItems: "flex-end" },
  sigText: { fontSize: 7.5 },

  sigNameRow: {
    flexDirection: "row",
    paddingHorizontal: 5,
    paddingVertical: 3,
  },
  sigNameLeft: { flex: 1 },
  sigNameRight: { flex: 1, alignItems: "flex-end" },
  sigNameText: { fontSize: 7.5 },

  // continued banner
  continuedRow: {
    paddingHorizontal: 5,
    paddingVertical: 2,
    borderBottomWidth: 1,
    borderBottomColor: "#000",
  },
  continuedText: { fontSize: 7, fontFamily: "Helvetica-Bold" },

  // page number outside outer border
  pageNum: {
    textAlign: "right",
    fontSize: 6.5,
    color: "#555",
    marginTop: 2,
    paddingHorizontal: 2,
  },
});

// ─── HATCHED BANNER ───────────────────────────────────────────────────────────
// Draws diagonal hatch stripes + centred bold text — matches original
const HatchBanner = ({ text }) => (
  <View style={S.hatchBanner}>
    {/* SVG hatch */}
    <Svg style={{ position: "absolute", top: 0, left: 0, right: 0, bottom: 0 }} viewBox="0 0 595 14">
      {Array.from({ length: 80 }).map((_, i) => (
        <Line
          key={i}
          x1={i * 10 - 14}
          y1={0}
          x2={i * 10}
          y2={14}
          stroke="#000"
          strokeWidth={0.6}
        />
      ))}
    </Svg>
    <Text style={S.hatchBannerText}>{text}</Text>
  </View>
);

// ─── INWARD CHALLAN HEADER ────────────────────────────────────────────────────
const InwardHeader = ({ data, isFirstPage }) => (
  <>
    {/* Row 1: GSTIN | Title | CIN */}
    <View style={S.topRow}>
      <View style={S.topLeft}>
        <View style={S.gstinLine}>
          <Text style={S.gstinText}>GSTIN : 07AACCN0524D1Z2</Text>
          <Text style={[S.challanTitle, { flex: 1 }]}>MATERIAL RECEIPT/INWARD CHALLAN</Text>
          <Text style={S.cinText}>CIN NO. U71220DL2005PTC133084</Text>
        </View>
        <Text style={S.receivedAtLine}>MATERIAL RECEIVED AT SITE/GODOWN</Text>
      </View>
      <View style={S.topRight}>
        <View style={S.sacRow}>
          <Text style={S.sacText}>SAC : 997313, 995457</Text>
        </View>
        <View style={[S.metaLineRow, { paddingVertical: 1 }]}>
          <Text style={S.metaLineLabel}>S. No. : </Text>
          <Text style={S.metaLineVal}>2026-27/</Text>
        </View>
        <View style={[S.metaLineRow]}>
          <Text style={S.metaLineLabel}>Date of Receiving :</Text>
          <Text style={S.metaLineVal}>{isFirstPage ? data.date : ""}</Text>
        </View>
        <View style={[S.metaLineRow]}>
          <Text style={S.metaLineLabel}>Place of Receiving :</Text>
          <Text style={S.metaLineVal}></Text>
        </View>
      </View>
    </View>

    {/* Row 2: Company name + address | meta right */}
    <View style={S.companyRow}>
      <View style={S.companyLeft}>
        <Text style={S.companyName}>NTS SCAFFOLDINGS PVT. LTD.</Text>
        <Text style={S.companyAddr}>
          KHASRA NO. 99/1, 99/2, 101/102, VILLAGE BUDHPUR, DELHI-110036{"\n"}
          REGD. OFFICE : 636, POCKET-C, IFC, GAZIPUR DELHI-110096
        </Text>
      </View>
      <View style={[S.companyRight, { justifyContent: "center" }]}></View>
    </View>

    {/* Row 3: Vehicle / GR */}
    <View style={S.vehicleRow}>
      <Text style={S.vehicleText}>Vehicle No. </Text>
      <View style={S.dotLine} />
      <Text style={{ marginLeft: 8, marginRight: 4 }}>G.R. No. </Text>
      <View style={S.dotLine} />
    </View>

    {/* Declaration block — first page only */}
    {isFirstPage && (
      <View style={S.declarationBox}>
        <Text style={S.declarationTitle}>DECLARATION</Text>
        <Text style={S.declarationLine}>
          Shuttering / Scaffolding Material Loaded in above mentioned Truck is bonafied property of{" "}
          <Text style={{ fontFamily: "Helvetica-Bold" }}>M/s. NTS Scaffoldings</Text>
        </Text>
        <Text style={S.declarationLine}>
          <Text style={{ fontFamily: "Helvetica-Bold" }}>Pvt. Ltd.</Text> The same was issued to M/s.
        </Text>
        <View style={S.dotLineInline} />
        <View style={S.dotLineInline} />
        <View style={S.dotLineInline} />
        <Text style={S.declarationLine}>having GSTIN...............................................................................for Civil Works on Hire Basis.</Text>
        <Text style={S.declarationLine}>This material is being returned after completion of work.</Text>
      </View>
    )}
  </>
);

// ─── OUTWARD CHALLAN HEADER ───────────────────────────────────────────────────
const OutwardHeader = ({ data, isFirstPage }) => (
  <>
    {/* Row 1: GSTIN + CIN | Title | right panel */}
    <View style={S.topRow}>
      <View style={S.topLeft}>
        <View style={S.gstinLine}>
          <Text style={S.gstinText}>GSTIN : 07AACCN0524D1Z2</Text>
          <Text style={{ flex: 1, textAlign: "right", fontFamily: "Helvetica-Bold", fontSize: 9 }}>DELIVERY/OUTWARD CHALLAN</Text>
        </View>
        <Text style={[S.gstinText, { marginTop: 1 }]}>CIN NO. U71220DL2005PTC133084</Text>
      </View>
      <View style={S.topRight}>
        <View style={S.sacRow}>
          <Text style={S.sacText}>SAC : 997313, 995457</Text>
        </View>
        <View style={[S.metaLineRow, { paddingVertical: 1 }]}>
          <Text style={S.metaLineLabel}>S. No. : </Text>
          <Text style={S.metaLineVal}>2026-27/</Text>
        </View>
        <View style={[S.metaLineRow]}>
          <Text style={S.metaLineLabel}>Date of Supply :</Text>
          <Text style={S.metaLineVal}>{isFirstPage ? data.date : ""}</Text>
        </View>
        <View style={[S.metaLineRow]}>
          <Text style={S.metaLineLabel}>Place of Supply :</Text>
          <Text style={S.metaLineVal}></Text>
        </View>
      </View>
    </View>

    {/* Row 2: Company name */}
    <View style={S.companyRow}>
      <View style={S.companyLeft}>
        <Text style={S.companyName}>NTS SCAFFOLDINGS PVT. LTD.</Text>
        <Text style={S.companyAddr}>
          KHASRA NO. 99/1, 99/2, 101/102, VILLAGE BUDHPUR, DELHI-110036{"\n"}
          REGD. OFFICE : 636, POCKET-C, IFC, GAZIPUR DELHI-110096
        </Text>
      </View>
      <View style={[S.companyRight, { justifyContent: "center" }]}></View>
    </View>

    {/* Consignee section — first page only */}
    {isFirstPage && (
      <View style={S.consigneeBox}>
        <View style={S.consigneeMsLine}>
          <Text style={S.consigneeMsLabel}>M/s.</Text>
          <View style={S.consigneeDotLine} />
        </View>
        <View style={S.consigneeBlankLine} />
        <View style={S.consigneeBlankLine} />
        <View style={S.consigneeGstinRow}>
          <Text style={S.consigneeGstinLabel}>GSTIN OF CONSIGNEE</Text>
          <View style={{ flex: 1, borderBottomWidth: 0.5, borderBottomColor: "#000", marginTop: 7 }} />
        </View>
      </View>
    )}

    {/* Vehicle / GR */}
    <View style={S.vehicleRow}>
      <Text style={S.vehicleText}>Vehicle No. </Text>
      <View style={S.dotLine} />
      <Text style={{ marginLeft: 8, marginRight: 4 }}>G.R. No. </Text>
      <View style={S.dotLine} />
    </View>

    {/* Receive notice */}
    <View style={{ borderBottomWidth: 1, borderBottomColor: "#000", paddingHorizontal: 5, paddingVertical: 3 }}>
      <Text style={{ fontFamily: "Helvetica-Bold", fontSize: 7.5 }}>PLEASE RECEIVE THE SCAFFOLDING / SHUTTERING MATERIAL AS FOLLOWS:</Text>
    </View>
  </>
);

// ─── TABLE ────────────────────────────────────────────────────────────────────
const ChallanTable = ({ items, showTotal, totalAmount, isLastPage }) => {
  const total = totalAmount.toLocaleString("en-IN", { minimumFractionDigits: 2 });
  return (
    <View>
      {/* Table header */}
      <View style={S.tableHeaderRow}>
        <View style={S.thSr}><Text style={S.thText}>Sr. No.</Text></View>
        <View style={S.thDesc}><Text style={S.thText}>DESCRIPTION OF GOODS</Text></View>
        <View style={S.thHsn}><Text style={S.thText}>HSN Code</Text></View>
        <View style={S.thQty}><Text style={S.thText}>QTY. (Nos.)</Text></View>
        <View style={S.thAmt}><Text style={S.thText}>AMOUNT (Rs.)</Text></View>
      </View>

      {/* Data rows */}
      {items.map((item, idx) => (
        <View key={item.srNo} style={S.dataRow}>
          <View style={S.tdSr}><Text style={S.tdText}>{item.srNo}</Text></View>
          <View style={S.tdDesc}><Text style={S.tdText}>{item.description}</Text></View>
          <View style={S.tdHsn}><Text style={[S.tdText, { textAlign: "center" }]}>{item.hsnCode}</Text></View>
          <View style={S.tdQty}><Text style={[S.tdText, { textAlign: "center" }]}>{item.qty}</Text></View>
          <View style={S.tdAmt}><Text style={S.tdText}>{item.amount.toLocaleString("en-IN", { minimumFractionDigits: 2 })}</Text></View>
        </View>
      ))}

      {/* Total row */}
      {showTotal && (
        <View style={S.totalRow}>
          <View style={S.totalSr}></View>
          <View style={S.totalDesc}></View>
          <View style={[S.totalHsn, { textAlign: "right" }]}>
            <Text style={S.totalText}>TOTAL</Text>
          </View>
          <View style={S.totalQty}></View>
          <View style={S.totalAmt}>
            <Text style={S.totalText}>{total}</Text>
          </View>
        </View>
      )}
    </View>
  );
};

// ─── INWARD FOOTER ────────────────────────────────────────────────────────────
const InwardFooter = ({ data }) => (
  <>
    <HatchBanner text="RETURNABLE MATERIAL ON HIRE. NOT FOR SALE" />
    <View style={S.valueLine}>
      <Text style={S.valueLabel}>Value (in figures)</Text>
      <View style={S.valueDotLine} />
      <Text style={S.valueLabel}>Value (in words)</Text>
      <View style={S.valueDotLine} />
    </View>
    <View style={S.sigRow}>
      <View style={S.sigLeft}><Text style={S.sigText}>Sign. of Hirer/Representative</Text></View>
      <View style={S.sigRight}><Text style={S.sigText}>For NTS SCAFFOLDINGS PVT. LTD.</Text></View>
    </View>
    <View style={S.sigNameRow}>
      <View style={S.sigNameLeft}><Text style={S.sigNameText}>Name of Receiver</Text></View>
      <View style={S.sigNameRight}><Text style={S.sigNameText}>Auth. Signatory</Text></View>
    </View>
  </>
);

// ─── OUTWARD FOOTER ───────────────────────────────────────────────────────────
const OutwardFooter = ({ data }) => (
  <>
    <HatchBanner text="RETURNABLE MATERIAL ON HIRE. NOT FOR SALE" />
    <View style={S.valueLine}>
      <Text style={S.valueLabel}>Value (in figures)</Text>
      <View style={S.valueDotLine} />
      <Text style={S.valueLabel}>Value (in words)</Text>
      <View style={S.valueDotLine} />
    </View>
    <View style={S.termsBox}>
      <Text style={S.termsIntro}>Received the above material in order &amp; in good condition on the terms stated below:</Text>
      <Text style={S.termLine}>1.   The material will be carried &amp; returned back by the hirer at his own cost &amp; responsibility.</Text>
      <Text style={S.termLine}>2.   The hirer shall be responsible for material lost or damaged &amp; shall be liable to compensate the owners at the rates agreed.</Text>
      <Text style={S.termLine}>3.   No receipt for material returned &amp; amount paid to the company shall be vaild unless signed by an authorised person.</Text>
      <Text style={S.termLine}>4.   The material received through this challan will not be transferred to any other site / project without written permission from</Text>
      <Text style={S.termLine}>      M/s. NTS Scaffoldings Pvt. Ltd.   5.  All disputes shall be subject to Delhi Jurisdiction only.</Text>
      <Text style={S.termLine}>6.   Unreturned Materials Cost will be Payble to us along with the hire Charges.</Text>
    </View>
    <View style={S.sigRow}>
      <View style={S.sigLeft}><Text style={S.sigText}>Sign. of Hirer/Representative</Text></View>
      <View style={S.sigRight}><Text style={S.sigText}>For NTS SCAFFOLDINGS PVT. LTD.</Text></View>
    </View>
    <View style={S.sigNameRow}>
      <View style={S.sigNameLeft}><Text style={S.sigNameText}>Name of Receiver</Text></View>
      <View style={S.sigNameRight}><Text style={S.sigNameText}>Auth. Signatory</Text></View>
    </View>
  </>
);

// ─── SINGLE DOCUMENT ──────────────────────────────────────────────────────────
const NTSDocument = ({ data }) => {
  const isDelivery = data.type === "DELIVERY";
  const pages = buildPages(data.items);
  const totalAmount = data.items.reduce((s, i) => s + i.amount, 0);
  const lastIdx = pages.length - 1;

  return (
    <Document
      title={`NTS ${isDelivery ? "Delivery" : "Receipt"} Challan ${data.serialNo}`}
      author="NTS Scaffoldings Pvt. Ltd."
    >
      {pages.map((pageItems, pageIdx) => {
        const isFirst = pageIdx === 0;
        const isLast  = pageIdx === lastIdx;
        return (
          <Page key={pageIdx} size="A4" style={S.page}>
            {/* top-right label */}
            <Text style={{ textAlign: "right", fontSize: 7, marginBottom: 2 }}>
              ORIGINAL FOR {isDelivery ? "CONSIGNEE" : "HIRER"}
            </Text>

            {/* outer border wraps everything */}
            <View style={S.outerBorder}>
              {/* HEADER */}
              {isDelivery
                ? <OutwardHeader data={data} isFirstPage={isFirst} />
                : <InwardHeader  data={data} isFirstPage={isFirst} />
              }

              {/* Continued notice on page 2+ */}
              {!isFirst && (
                <View style={S.continuedRow}>
                  <Text style={S.continuedText}>
                    (Continued from previous page — S.No. {data.serialNo})
                  </Text>
                </View>
              )}

              {/* TABLE */}
              <ChallanTable
                items={pageItems}
                showTotal={isLast}
                totalAmount={totalAmount}
                isLastPage={isLast}
              />

              {/* FOOTER — last page only */}
              {isLast && (
                isDelivery
                  ? <OutwardFooter data={data} />
                  : <InwardFooter  data={data} />
              )}

              {/* Continuation note on non-last pages */}
              {!isLast && (
                <View style={{ padding: 4, borderTopWidth: 1, borderTopColor: "#000" }}>
                  <Text style={{ fontSize: 7, textAlign: "center" }}>
                    — Continued on next page —
                  </Text>
                </View>
              )}
            </View>

            {/* page number outside outer border */}
            <Text
              style={S.pageNum}
              render={({ pageNumber, totalPages }) => `Page ${pageNumber} of ${totalPages}`}
            />
          </Page>
        );
      })}
    </Document>
  );
};

// ─── APP ──────────────────────────────────────────────────────────────────────
export default function App() {
  const [ready, setReady] = useState(false);
  const [mode, setMode] = useState("DELIVERY"); // "DELIVERY" | "RECEIPT"

  useEffect(() => {
    const t = setTimeout(() => setReady(true), 300);
    return () => clearTimeout(t);
  }, []);

  const data = mode === "DELIVERY" ? deliveryData : receiptData;

  return (
    <div style={{ fontFamily: "system-ui,sans-serif", background: "#f1f5f9", minHeight: "100vh", display: "flex", flexDirection: "column", alignItems: "center", padding: "16px" }}>
      {/* toolbar */}
      <div style={{ width: "100%", maxWidth: 860, display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 12 }}>
        <div>
          <h2 style={{ margin: 0, fontSize: 16, fontWeight: 700, color: "#1e293b" }}>NTS Scaffoldings — Challan Generator</h2>
          <p style={{ margin: "2px 0 0", fontSize: 11, color: "#64748b" }}>
            {data.items.length} items · {buildPages(data.items).length} page(s)
          </p>
        </div>
        <div style={{ display: "flex", gap: 8 }}>
          {["DELIVERY", "RECEIPT"].map(t => (
            <button
              key={t}
              onClick={() => { setReady(false); setMode(t); setTimeout(() => setReady(true), 200); }}
              style={{
                padding: "6px 16px",
                borderRadius: 4,
                border: "1.5px solid #334155",
                background: mode === t ? "#1e293b" : "#fff",
                color: mode === t ? "#fff" : "#1e293b",
                fontWeight: 600,
                fontSize: 12,
                cursor: "pointer",
              }}
            >
              {t === "DELIVERY" ? "Outward / Delivery" : "Inward / Receipt"}
            </button>
          ))}
        </div>
      </div>

      {/* viewer */}
      <div style={{ width: "100%", maxWidth: 860, borderRadius: 6, overflow: "hidden", boxShadow: "0 4px 24px rgba(0,0,0,0.15)", background: "#fff", minHeight: 600, display: "flex", alignItems: "center", justifyContent: "center" }}>
        {ready ? (
          <PDFViewer width="100%" height={680} style={{ border: "none" }}>
            <NTSDocument data={data} />
          </PDFViewer>
        ) : (
          <div style={{ color: "#94a3b8", fontSize: 13 }}>Rendering PDF…</div>
        )}
      </div>
      <p style={{ color: "#64748b", fontSize: 11, marginTop: 8 }}>
        Switch between Outward and Inward challan using the buttons above. Use the ↓ button in the viewer to download.
      </p>
    </div>
  );
}